<div class="recent-opportunities">

  <h3>Recent Opportunities</h3>

  <ng-container *appLoad="let data of opportunities$; trackingName: 'dashboard-opportunity-list'">

    <ng-container *ngIf="data.length; else tplNoResults">
      <app-opportunity-list-view
        [opportunities]="data | slice:0:3"
        [isNavigatable]="true">
      </app-opportunity-list-view>
    </ng-container>

  </ng-container>

</div>

<!-- templates -->

<!-- tpl / no results -->
<ng-template #tplNoResults>

  <lds-empty-state
    heading="No opportunities found"
    message="Looks like you haven't added any opportunities just yet. You will see your recent opportunities here once created.">
  </lds-empty-state>

</ng-template>
